export{a as apiConfig,f as featureToggles}from"./feature-toggles-e9cc698c.js";export{g as gtmConfig}from"./google-tag-manager-1fab6af4.js";import"next/config";import"@swc/helpers";import"@grandvisionhq/state";
//# sourceMappingURL=configuration.js.map
